var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGardenWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1922_4305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.547 11.8206C17.3132 11.4698 17.5646 11 17.9862 11C18.4132 11 18.6635 10.5193 18.4186 10.1695L12.8221 2.17453C12.4232 1.60465 11.5788 1.60607 11.1818 2.17729L5.6168 10.1844C5.37751 10.5287 5.6239 11 6.04318 11C6.45516 11 6.70306 11.4568 6.47853 11.8022L4.10422 15.455C3.6718 16.1203 4.14922 17 4.94266 17H9.01998C9.57226 17 10.02 17.4477 10.02 18V20C10.02 20.5523 10.4677 21 11.02 21H12.98C13.5323 21 13.98 20.5523 13.98 20V18C13.98 17.4477 14.4277 17 14.98 17H19.1315C19.9302 17 20.4065 16.1099 19.9635 15.4453L17.547 11.8206Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1922_4305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardenWhite);
export default __webpack_public_path__ + "static/media/garden-white.d66fe29beb9f916497c4ef8aaf600af0.svg";
export { ForwardRef as ReactComponent };